import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField } from "../../../../../../../../../api/types/svTypes.ts";
import { isFieldSupportedLogoIcon } from "./isFieldSupportedLogoIcon";

interface Props {
  field: DimensionField;
  onUpdateConfig: (field: DimensionField, changes: Partial<FieldConfiguration>) => void;
  readonlyMode: boolean;
}

export default function ShowLogoIconComponent({ field, onUpdateConfig, readonlyMode }: Props) {
  const showLogoIconOptions = useMemo(() => {
    const isRowField = isFieldSupportedLogoIcon(field);

    return isRowField;
  }, [field]);

  const updateShowLogoIcon = useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onUpdateConfig(field, { showLogoIcon: checked });
    },
    [field, onUpdateConfig]
  );

  if (showLogoIconOptions === false) return null;

  return (
    <FormControlLabel
      disabled={readonlyMode}
      key={`${field.config.guid}_logoOptions`}
      control={
        <Checkbox
          disabled={readonlyMode}
          sx={{ p: "2px .4rem 2px 0" }}
          disableRipple
          disableFocusRipple
          disableTouchRipple
          checked={field.config.showLogoIcon === true}
          onChange={updateShowLogoIcon}
        />
      }
      label={
        <Stack direction={"row"} sx={{ gap: 0.5 }}>
          <Typography>Show Company Logo</Typography>
          <Typography color="secondary">(if available)</Typography>
        </Stack>
      }
    />
  );
}
